import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import MeetingFeature from './features/meeting';
import SummaryFeature from './features/summary';
import { selectIsPrivileged } from '../../../auth/ducks';

function AgreementsFeature() {
  const isPrivileged = useSelector(selectIsPrivileged);

  return (
    <Routes>
      <Route path="meeting" element={<MeetingFeature isPrivileged={isPrivileged} />} />
      <Route path="summary" element={<SummaryFeature isPrivileged={isPrivileged} />} />
      <Route path="*" element={<Navigate to="../meeting" replace />} />
    </Routes>
  );
}

export default AgreementsFeature;
